const TTL_MS = 30_000;

interface CacheEntry {
  at: number;
  promise: Promise<any>;
}

const cache = new Map<string, CacheEntry>();

export async function cachedConnectionCheck<T>(
  key: string,
  fetcher: () => Promise<T>
): Promise<T> {
  const now = Date.now();
  const hit = cache.get(key);
  if (hit && now - hit.at <= TTL_MS) {
    return hit.promise as Promise<T>;
  }

  const promise = (async () => {
    try {
      return await fetcher();
    } catch (err) {
      const current = cache.get(key);
      if (current && current.promise === promise) cache.delete(key);
      throw err;
    }
  })();

  cache.set(key, { at: now, promise });
  return promise;
}

export function clearConnectionCheckCache(keyPrefix?: string): void {
  if (!keyPrefix) {
    cache.clear();
    return;
  }
  for (const k of Array.from(cache.keys())) {
    if (k.startsWith(keyPrefix)) cache.delete(k);
  }
}
